import { createStyles, makeStyles } from "@material-ui/core/styles";


export default makeStyles((theme) => createStyles({
    container: {
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.grey["300"],
        borderRadius: 4,
    },
    iconSpace: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: theme.palette.common.white,
        borderRadius: "50%",
        height: 56,
        width: 56,
        padding: 18,
    },
    icon: {
        color: theme.palette.grey["300"],
    },
}));
